export default "__VITE_ASSET__DHtpeeUq__"